import { gql } from '@apollo/client';

export default gql`
  query searchDiscountCodes($validTravelDate: String, $validSalesDate: String) {
    searchDiscountCodes(validTravelDate: $validTravelDate, validSalesDate: $validSalesDate) {
      reference
      alias
      type
      status
      amount
      value
      balance
      currency
      validUntil
      salesPeriodStart
      salesPeriodEnd
      travelPeriodStart
      travelPeriodEnd
      createdBy
      createdAt
      description
      isActive
      valueType
    }
  }
`;
